"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListBoxActionsWrapper = exports.StyledPaper = exports.StyledMultiSelector = exports.StyledMenuList = exports.StyledAutocompleteSelector = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAutocompleteSelector = (0, styled_components_1.default)(ui_components_1.Autocomplete) `
  &.MuiAutocomplete-root > .MuiFormControl-root > .MuiInputBase-root.MuiOutlinedInput-root {
    height: ${({ theme: { spacing } }) => spacing(5.75)};
    min-height: 0px;
    padding: ${({ theme: { spacing } }) => spacing(0.75)};
    background-color: ${ui_components_1.baseColors.white};

    &.Mui-disabled {
      background-color: ${ui_components_1.baseColors.background100};
    }

    .MuiAutocomplete-input {
      padding: ${({ theme: { spacing } }) => spacing(0.3125, 0.5, 0.3125, 0.75)};
    }
  }
`;
exports.StyledMenuList = (0, styled_components_1.default)(material_1.MenuList) `
  &&.list--loading > li {
    color: ${({ theme }) => theme.palette.grey[500]};
  }
  li {
    border-radius: 4px;

    &:hover {
      background-color: ${ui_components_1.baseColors.primaryAccentGreen800};
    }
  }

  .load-more-indicator {
    padding: ${({ theme }) => theme.spacing(1)};
  }
`;
exports.StyledMultiSelector = (0, styled_components_1.default)(material_1.Autocomplete) `
  && .text-field--small .MuiInputBase-root {
    min-height: 46px;
  }

  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root {
    padding-right: 48px;
  }
`;
exports.StyledPaper = (0, styled_components_1.default)(material_1.Paper) `
  && {
    padding: 8px;
    margin: 0;
    box-shadow: ${ui_components_1.shadows.backgroundCardHover};
    border-radius: 8px;
    .MuiAutocomplete-listbox {
      padding: 0;
    }
    .MuiAutocomplete-option {
      padding: 12px 16px;
      border-radius: 4px;
      color: ${ui_components_1.baseColors.primaryBlueDark500};
    }
    .Mui-focused,
    .Mui-selected {
      background-color: ${ui_components_1.baseColors.primaryGreen000};
      color: ${ui_components_1.baseColors.primaryGreen700};
    }
  }
`;
exports.StyledListBoxActionsWrapper = styled_components_1.default.div `
  padding: ${({ theme }) => theme.spacing(1.75, 2, 1.75, 1)};
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  background: #F8F8FA;
`;
